// HelpReportingPage.tsx — /help/reporting.
//
// The support surface for the platform's central mechanism. The text lives
// in core/data/help/reporting.ts — authored once, rendered here and served to
// the app by GET /api/help/reporting/ — so read that file for what the page
// says and why.
//
// Public: no sign-in gate. Someone deciding whether this place is for them has
// to be able to read how it polices itself first.

import { helpReporting } from '@/core/data/help';
import { HelpDocumentView } from './HelpDocumentView';

export function HelpReportingPage() {
  return <HelpDocumentView doc={helpReporting} />;
}
